@if (spinnerService.isLoading()) {
  <div class="overlay">
    <p-progress-spinner class="customProgressSpinner"></p-progress-spinner>
  </div>
}
